import { useToggle } from 'usehooks-ts';
import { useEffect, useState } from 'react';

import { TextareaInput } from '../form-input';
import { Label } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
import { Checkbox } from '@progress/kendo-react-inputs';
import {
  UploadedImage,
  ResourceWindow
} from '../../features/game-document/image-resource/resource-window';

interface CustomFeedbackMessageProps {
  url: string;
  title: string;
  message?: string;
  isDefault?: boolean;
  onMessageChange: (message: string) => void;
  onChangeIsDefault: (isDefault: boolean) => void;
  onImageChange: (uploadedImage: UploadedImage) => void;
}

export const CustomFeedbackMessage = ({
  url,
  title,
  message,
  isDefault,
  onImageChange,
  onMessageChange,
  onChangeIsDefault
}: CustomFeedbackMessageProps) => {
  const [imageUrl, setImageUrl] = useState(url);
  const [showUploader, setShowUploader] = useToggle(false);

  useEffect(() => {
    setImageUrl(url);
  }, [url]);

  return (
    <>
      <div className={'d-flex flex-column'}>
        <Checkbox
          name={'checkbox-use-default'}
          label={'Use default'}
          value={isDefault}
          onChange={(e) => onChangeIsDefault(e.value)}
        />
        <Label className={'mt-3'}>{title}</Label>
      </div>

      <div className={'d-flex flex-row'}>
        <div className={'mt-3'}>
          <img height={100} src={imageUrl} alt="Checked" />
        </div>
        <div className={'p-1 align-self-center mt-3 ml-3'}>
          <Button disabled={isDefault} onClick={setShowUploader}>
            Upload image
          </Button>
        </div>
      </div>
      <div className={'mt-3 w-full'}>
        <TextareaInput
          disabled={isDefault}
          value={message}
          className={'w-full'}
          label={'Custom message'}
          name={'custom-message'}
          maxLength={300}
          rows={3}
          onChange={(e) => {
            onMessageChange(e.target.value ?? '');
          }}
        />
      </div>
      {showUploader && (
        <ResourceWindow
          toggleDialog={setShowUploader}
          onSubmit={(uploadedFile) => {
            setShowUploader();
            setImageUrl(uploadedFile.blobUrl);
            onImageChange(uploadedFile);
          }}
          fileType={['image']}
          defaultSelectedCategory={'Task Feedback icons'}
        />
      )}
    </>
  );
};
